const {
  compose,
  createMapEntry,
  path,
  prop,
  tap,
} = require('ramda')

const httpFuture = require('./http-future')
const setAuthToken = require('./set-auth-token')

const getBody = prop('body')
const getExists = path([ 'body', 'exists' ])
const handleAuthResponse = compose(tap(setAuthToken), getBody)
const createSignupParams = function (email, password) {
  return {
    password,
    user: {
      email,
    },
  }
}
const { postWithData } = httpFuture

module.exports = {

  login (loginData) {
    return postWithData('/login', loginData)
      .map(handleAuthResponse)
  },

  loginAdmin (loginData) {
    return postWithData('/loginadmin', loginData)
      .map(handleAuthResponse)
  },

  accountExists (account) {
    const query = createMapEntry('account', account)
    return httpFuture.getWithQuery('/accountexists', query).map(getExists)
  },

  signup (email, password) {
    return postWithData('/signup', createSignupParams(email, password)).map(handleAuthResponse)
  },

  activate (code, data) {
    const uri = `/activations/${code}`
    return postWithData(uri, data).map(handleAuthResponse)
  },

  forgotPassword (email) {
    return postWithData('/forgotpassword', createMapEntry('email', email)).map(getBody)
  },

  resetPassword (code, data) {
    return postWithData(`/resetpassword/${code}`, data).map(handleAuthResponse)
  },

}
